import { ApiService } from './api.service';
import { AuthInfo } from '@/models/auth-info';
import { SocialLoginDef } from '@/constants/socialLoginDef';

class AuthorizationService extends ApiService {
  constructor() {
    super();
  }

  /**
   * Do user sigin
   * @param email Login ID
   * @param password Login password
   */
  public signin(email: string, password: string, authCode: string = ""): Promise<AuthInfo> {
    return this.post<AuthInfo>(AuthInfo, `/signin`, { email: email, password: password, authCode: authCode });
  }

  /**
   * Do user signout
   */
  public signout(): Promise<AuthInfo> {
    return this.post<AuthInfo>(AuthInfo, `/signout`, {});
  }

  /**
   * Signin for iGSAccount
   * @param token
   */
  public signinForIgsAccount(token: string): Promise<AuthInfo> {
    return this.post<AuthInfo>(AuthInfo, `/signinForIgsAccount`, { token: token });
  }

  public getAuthInfo(email: string, password: string): Promise<AuthInfo> {
    return new Promise(function(resolve, _) {
      setTimeout(() => resolve('done!'), 100);
      //setTimeout(()=> {  console.log(); }, 100);
    }).then(_ => {
      const mockData = require('@/assets/mock-data/users.json');
      return mockData.data.map((d: any) => new AuthInfo().deserialize(d));
    });
  }

  /**
   * ソーシャルログイン.
   * @param code
   * @param type
   */
  public socialSignin(code: string, type: string): Promise<AuthInfo> {
    switch (type) {
      case SocialLoginDef.Google:{
        const redirectUri = process.env.VUE_APP_OAUTH2_REDIRECT_URI;
        let params: any = {
          code,
          redirectUri,
        };
        return this.post(AuthInfo, '/googleLogin', params);
      }

      case SocialLoginDef.Microsoft:{
        const redirectUri = process.env.VUE_APP_MS_OAUTH2_REDIRECT_URI;
        let params: any = {
          code,
          redirectUri,
        };
        return this.post(AuthInfo, '/microsoftLogin', params);
      }
        
    }
  }
}

export const authService = new AuthorizationService();
